/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import ProductDetail from '@/views/ProductDetail.vue';
import CartPage from '@/views/CartPage.vue';
import CheckoutPage from '@/views/CheckoutT.vue';
import UserCenter from '@/views/UserCenter.vue';
import UserAddress from '@/views/user/UserAddress.vue';
import UserDashboard from '@/views/user/UserDashboard.vue';
import UserProfile from '@/views/user/UserProfile.vue';
import UserEarnings from '@/views/user/UserEarnings.vue';
import UserInvites from '@/views/user/UserInvites.vue';
import UserOrders from '@/views/user/UserOrders.vue';
import UserOrderDetail from '@/views/user/UserOrderDetail.vue';
import GeneralLayout from '@/layouts/GeneralLayout.vue';
import AgentLayout from '@/layouts/AgentLayout.vue';
import AgentDashboard from '@/views/AgentDashboard.vue';
import AgentPerformance from '@/views/AgentPerformance.vue';
import AgentEarnings from '@/views/AgentEarnings.vue';
import SubAgentManagement from '@/views/SubAgentManagement.vue';
import UpgradeRules from '@/views/UpgradeRules.vue';
import AgentLogin from '@/views/AgentLogin.vue';
import AgentList from "@/views/AgentList.vue";
import AgentWholesaler from "@/views/AgentWholesaler.vue";
const host = window.location.host;
let routes = [];
// dailishang
// if(true){
if(host.includes(process.env.VUE_APP_AGENT_BASE_URL)){
  routes = [
    {
      path: '/',
      component: AgentLayout,
      children: [
        {
          path: '/',
          name: 'agent-login',
          component: AgentLogin,
          props: true
        },
        {
          path: 'dashboard',
          name: 'agent-dashboard',
          component: AgentDashboard,
          props: true
        },
        {
          path: 'performance',
          name: 'agent-performance',
          component: AgentPerformance,  
          props: true
        },
        {
          path: 'earnings',
          name: 'agent-earnings',
          component: AgentEarnings,
          props: true
        },
        {
          path: 'sub-agents',
          name: 'sub-agent-management',
          component: SubAgentManagement,
          props: true
        },
        {
          path: 'wholesaler',
          name: 'agent-wholesaler',
          component: AgentWholesaler,
          props: true
        },
        {
          path: 'upgrade-rules',
          name: 'agent-upgrade-rules',
          component: UpgradeRules,
          props: true
        },
        {
          path: "direct",
          name: "direct-list",
          component: AgentList,
          props: true
        }
      ],
    },
  ];
} else {
  routes = [
    {
        path: '/',
        component:  GeneralLayout,
        props: true,
        children: [
            {
            path: '/',
            name: 'Home',
            component: HomePage,
            props: true,
            },
            {
            path: '/product/featured',
            name: 'ProductDetail',
            component: ProductDetail,
            props: true,
            },
            {
            path: '/cart',
            name: 'CartPage',
            component: CartPage,
            props: true,
            },
            {
            path: '/checkout',
            name: 'Checkout',
            component: CheckoutPage,
            props: true,
            }
        ]
    },
    {
      path: '/dashboard',
      component: UserCenter,
      props: true,
      children: [
          {
          path: '',
          name: 'dashboard',
          component: UserDashboard,
          props: true,
          },
          {
          path: 'profile',
          name: 'dashboard-profile',
          component: UserProfile,
          props: true,
          },
          {
          path: 'order',
          name: 'dashboard-order',
          component: UserOrders,
          props: true,
          },
          {
            path: 'order/:orderId',
            name: 'dashboard-order-detail',
            component: UserOrderDetail,
            props: true,
          },
          {
          path: 'address',
          name: 'dashboard-address',
          component: UserAddress,
          props: true,
          },
          {
          path: 'earnings',
          name: 'dashboard-earnings',
          component: UserEarnings,
          props: true,
          },
          {
          path: 'invites',
          name: 'dashboard-invites',
          component: UserInvites,
          props: true,
          },
      ],
    },
  ];
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (process.env.NODE_ENV === 'development') {
//     // 在开发模式下，允许直接访问代理页面
//     next();
//   } else {
//     const host = window.location.host;
//     if (host.includes(process.env.VUE_APP_AGENT_BASE_URL)) {
//       // 如果是代理商域名，重定向到代理商面板
//         const newPath = to.path.replace('/agent', '');
//         if(to.name !== "agent-login") {
//           return next({ path: '/login' });
//         }
//         return next({ path: newPath });
//     } else {
//       // 如果是普通用户域名，重定向到用户主页
//       if (to.path.startsWith('/agent')) {
//         return next({ name: 'Home' });
//       }
//     }
//     next();
//   }
// });

export default router;
